export default __webpack_public_path__ + "static/media/logo.d2ef31b2.png";